var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "40%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.onHandleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "contents1" },
            [
              _c("div", { staticClass: "mb-10" }, [
                _vm._v("品类：" + _vm._s(_vm.cName)),
              ]),
              _c(
                "el-form",
                {
                  ref: "platForm",
                  attrs: {
                    model: _vm.platForm,
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "属性名称", prop: "field_key" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入属性名称",
                          maxlength: "10",
                        },
                        model: {
                          value: _vm.platForm.field_key,
                          callback: function ($$v) {
                            _vm.$set(_vm.platForm, "field_key", $$v)
                          },
                          expression: "platForm.field_key",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "属性值", prop: "field_map" } },
                    _vm._l(_vm.platForm.field_map, function (uItem, uIndex) {
                      return _c(
                        "div",
                        { key: uIndex, staticClass: "d-flex a-center mb-10" },
                        [
                          _c(
                            "div",
                            { staticClass: "mr10" },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "输入属性值",
                                  maxlength: "10",
                                },
                                model: {
                                  value: uItem.value,
                                  callback: function ($$v) {
                                    _vm.$set(uItem, "value", $$v)
                                  },
                                  expression: "uItem.value",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("i", {
                            staticClass: "el-icon-plus",
                            staticStyle: { "margin-right": "10px" },
                            on: { click: _vm.addValue },
                          }),
                          _c("i", {
                            staticClass: "el-icon-delete",
                            staticStyle: { "margin-right": "10px" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteValue(uIndex)
                              },
                            },
                          }),
                          _c("i", {
                            staticClass: "el-icon-top",
                            staticStyle: { "margin-right": "10px" },
                            on: {
                              click: function ($event) {
                                return _vm.moveUp(uIndex)
                              },
                            },
                          }),
                          _c("i", {
                            staticClass: "el-icon-bottom",
                            staticStyle: { "margin-right": "10px" },
                            on: {
                              click: function ($event) {
                                return _vm.moveDown(uIndex)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "必选", prop: "is_must" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.platForm.is_must,
                            callback: function ($$v) {
                              _vm.$set(_vm.platForm, "is_must", $$v)
                            },
                            expression: "platForm.is_must",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "sort" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入排序" },
                        model: {
                          value: _vm.platForm.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.platForm, "sort", $$v)
                          },
                          expression: "platForm.sort",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }